import React from 'react';

import { DateTime } from 'luxon';

import { Box, COLORS, FontWeight, Text } from '@clutter/clean';

import { CouponFragment } from '@graphql/platform';

import { useSharedCheckoutContext } from '@root/components/checkout/context';

import { Currency } from '@shared/currency';

export const LaborAdjustmentBanner: React.FC<{
  date: DateTime;
  coupon: CouponFragment;
}> = ({ date, coupon }) => {
  const { pricingSummary } = useSharedCheckoutContext();
  return (
    <Box.Flex
      background={COLORS.cloud}
      border="1px solid"
      borderRadius="4px"
      borderColor={COLORS.sunshine}
      padding="16px 16px"
      gap="16px"
      justifyContent="space-evenly"
    >
      <Box>
        <Text.Callout>
          Great news! Booking on {date.toFormat('MMMM d')} gives you{' '}
          <strong>
            {coupon.percent ? (
              coupon.percent * 100 + '%'
            ) : (
              <Currency amount={coupon.amount} />
            )}{' '}
            off
          </strong>{' '}
          your first month of storage.
        </Text.Callout>
      </Box>
      <Box textAlign="right">
        {pricingSummary?.monthlyAmount && (
          <Text.Body color={COLORS.tealPrimary} weight={FontWeight.Medium}>
            <Currency amount={pricingSummary.monthlyAmount} />
            /mo
          </Text.Body>
        )}
      </Box>
    </Box.Flex>
  );
};
